/** @internal */
export function createRequiredDirective() {

    return {

        require: "?ngModel",
        restrict: "A",

        link: (scope, element, attr, ctrl: ng.INgModelController) => {

            if (!ctrl) return;


            var formGroup = element;

            while (formGroup && !formGroup.hasClass("form-group")) {
                formGroup = formGroup.parent();
            }

            var target = formGroup || element;

            ctrl.$validators["required"] = function(modelValue, viewValue) {
                return !attr.required || !ctrl.$isEmpty(viewValue);
            };

            scope.$watch(attr.omniaRequired, reqd => {

                attr.required = reqd;

                if (reqd) {
                    target.addClass("required");
                } else {
                    target.removeClass("required");
                }

                ctrl.$validate();

            });

        }

    }

}
